<template>
  <section class="py-7 mb-5" id="reviews">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="bg-holder bg-size" v-bind:style="backgroundImage"></div>

        <div class="col-md-8 col-lg-5 text-center">
          <h5 class="text-danger">Comentarios De</h5>
          <h3>Nuestros Clientes</h3>
        </div>
      </div>
    </div>

    <div
      class="carousel slide pt-6 pb-5"
      id="carouselExampleDark"
      data-bs-ride="carousel"
    >
      <div class="carousel-inner">
        <div class="carousel-item active" data-bs-interval="5000">
          <div class="row h-100">
            <div class="col-md-4 mb-3 mb-md-0">
              <div class="card h-100 card-span p-3">
                <div class="card-body">
                  <h5 class="mb-0 text-primary">Me encanto la plataforma!</h5>
                  <p class="card-text pt-3">
                    La plataforma es de facil manejo y me fue de mucha utilidad.
                    El personal que vino a mi casa brindo un servicio muy bueno
                  </p>
                  <div
                    class="d-xl-flex justify-content-between align-items-center"
                  >
                    <div class="d-flex align-items-center mb-3">
                      <i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i>
                    </div>
                    <div class="d-flex align-items-center">
                      <img
                        class="img-fluid user-avatar"
                        src="../../../assets/img/gallery/pic5.png"
                        alt=""
                      />
                      <div class="flex-1 ms-3">
                        <h6 class="mb-0 fs--1 text-1000 fw-medium">
                          Floreydis Campusano
                        </h6>
                        <p class="fs--2 fw-normal mb-0">Nutricionista</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 mb-3 mb-md-0">
              <div class="card h-100 card-span p-3">
                <div class="card-body">
                  <h5 class="mb-0 text-primary">Servicio de Primera!</h5>
                  <p class="card-text pt-3">
                    Esta plataforma es muy amena y fiable, es muy facil de
                    manejar y el servicio que ofrece a traves del personal es de
                    muy buena calidad.
                  </p>
                  <div
                    class="d-xl-flex justify-content-between align-items-center"
                  >
                    <div class="d-flex align-items-center mb-3">
                      <i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i>
                    </div>
                    <div class="d-flex align-items-center">
                      <img
                        class="img-fluid user-avatar"
                        src="../../../assets/img/gallery/pic7.png"
                        alt=""
                      />
                      <div class="flex-1 ms-3">
                        <h6 class="mb-0 fs--1 text-1000 fw-medium">
                          Pedro Alcántara
                        </h6>
                        <p class="fs--2 fw-normal mb-0">Choffer</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 mb-3 mb-md-0">
              <div class="card h-100 card-span p-3">
                <div class="card-body">
                  <h5 class="mb-0 text-primary">Tranquilidad Total!</h5>
                  <p class="card-text pt-3">
                    Me siento satisfecha con la plataforma porque por medio a
                    ella he encontrado la persona que me ha dado el servicio de
                    pintura para mi casa el cual quedo excelente.
                  </p>
                  <div
                    class="d-xl-flex justify-content-between align-items-center"
                  >
                    <div class="d-flex align-items-center mb-3">
                      <i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i>
                    </div>
                    <div class="d-flex align-items-center">
                      <img
                        class="img-fluid user-avatar"
                        src="../../../assets/img/gallery/Pic6.jpeg"
                        alt=""
                      />
                      <div class="flex-1 ms-3">
                        <h6 class="mb-0 fs--1 text-1000 fw-medium">
                          Dahira Suero
                        </h6>
                        <p class="fs--2 fw-normal mb-0">Programadora</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item" data-bs-interval="2000">
          <div class="row h-100">
            <div class="col-md-4 mb-3 mb-md-0">
              <div class="card h-100 card-span p-3">
                <div class="card-body">
                  <h5 class="mb-0 text-primary">
                    Lo mejor que pudieron crear!
                  </h5>
                  <p class="card-text pt-3">
                    Me recomendaron esta plataforma y he quedado encantada. Hace
                    3 dias solicite un servicio de plomeria y el chico que vino
                    a mi casa hizo un trabajo de primera.
                  </p>
                  <div
                    class="d-xl-flex justify-content-between align-items-center"
                  >
                    <div class="d-flex align-items-center mb-3">
                      <i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i
                      ><i class="fas fa-star text-primary me-1"></i>
                    </div>
                    <div class="d-flex align-items-center">
                      <img
                        class="img-fluid user-avatar"
                        src="../../../assets/img/gallery/pic2.jpeg"
                        alt=""
                      />
                      <div class="flex-1 ms-3">
                        <h6 class="mb-0 fs--1 text-1000 fw-medium">
                          Arielle de Madet
                        </h6>
                        <p class="fs--2 fw-normal mb-0">Programadora</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ol class="carousel-indicators">
        <li
          class="active"
          data-bs-target="#carouselExampleDark"
          data-bs-slide-to="0"
        ></li>
        <li data-bs-target="#carouselExampleDark" data-bs-slide-to="1"></li>
      </ol>
    </div>
  </section>
</template>

<script>
export default {
  name: "customer-reviews",
  data() {
    return {
      // backgroundImage: `background-image:url(${require("../../assets/img/gallery/quote.png")})` + ";background-position:top;background-size:auto;margin-left:-270px;margin-top:-45px;"
      backgroundImage:
        `background-image:url(${require("../../../assets/img/gallery/quote.png")})` +
        ";",
    };
  },
};
</script>

<style scoped>
.user-avatar {
  border-radius: 50%;
  object-fit: cover;
  height: 5rem;
  width: 5rem;
  margin-top: 2rem;
}
.carousel-indicators [data-bs-target] {
  background-color: #3f51b5;
}
.carousel-indicators li {
  width: 10px;
  height: 10px;
  border-radius: 100%;
}
</style>
